// URL utility functions for creating and handling pretty URLs

/**
 * Generate a URL-friendly slug from a string
 * @param {string} text - The text to convert to a slug
 * @returns {string} - URL-friendly slug
 */
export const generateSlug = (text) => {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .trim()
    // Replace spaces and special characters with hyphens
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '');
};

/**
 * Check if a string is a valid UUID
 * @param {string} str - String to check
 * @returns {boolean} - True if valid UUID
 */
export const isUUID = (str) => {
  if (!str) return false;
  
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

/**
 * Generate a pretty URL for a game
 * @param {Object} game - Game object with id and title
 * @returns {string} - Pretty URL path
 */
export const generateGameUrl = (game) => {
  if (!game || !game.title) return `/games/${game?.id || ''}`;
  
  const slug = generateSlug(game.title);
  return `/games/${slug}`;
};

/**
 * Extract game identifier from URL parameter
 * @param {string} param - URL parameter (could be slug or UUID)
 * @returns {Object} - Object with type and value
 */
export const parseGameParam = (param) => {
  if (!param) return { type: 'invalid', value: null };
  
  if (isUUID(param)) {
    return { type: 'uuid', value: param };
  } else {
    return { type: 'slug', value: param };
  }
};
